<div
  class="chat-state-panel d-flex flex-column align-items-center justify-content-center text-center gap-2 px-3"
  [class.py-5]="!compact"
  [class.py-4]="compact"
>
  <!-- Hyper pattern: soft disc + semantic glyph live on the `avatar-title` itself.
       `avatar-title` paints a solid `--ct-primary` background, so a soft tint on
       the WRAPPER sat invisible behind it (indigo disc, indigo glyph on the full
       view). `bg-soft-*` carries !important and wins on the same element. -->
  <div [ngClass]="compact ? 'avatar-sm' : 'avatar-lg'">
    <i
      class="avatar-title rounded-circle bg-soft-primary text-primary"
      [ngClass]="[icon, compact ? 'font-18' : 'font-24']"
    ></i>
  </div>

  <h5 class="mb-0">{{ titleKey | translate }}</h5>

  @if (hintKey) {
    <p class="text-muted mb-0">{{ hintKey | translate }}</p>
  }

  @if (actionKey) {
    <button type="button" class="btn btn-sm btn-primary mt-1" (click)="action.emit()">
      <i class="me-1" [ngClass]="actionIcon"></i>{{ actionKey | translate }}
    </button>
  }
</div>
